import React from 'react';
import PropTypes from 'prop-types';
import ContentCard from '../../_common/ContentCard';
import ContentHeading from '../../_common/ContentHeading';

export default function Template(props) {
  const {
    title,
    subtitle,
    icon,
    tags,
    link,
    children
  } = props;

  return (
    <ContentCard>
      <ContentHeading
        icon={icon}
        title={title}
        subtitle={subtitle}
      />
      {children}
      {tags && (
        <ul className="list-disc ml-6 text-gray-500">
          {tags.data.map(function(tag) {
            return (
              <li key={tag.id || tag.cid}>
                {tag.data.name}
              </li>
            );
          })}
        </ul>
      )}
    </ContentCard>
  );
}
